import Vue from 'vue';
import { Icon } from '@iconify/vue2';
import VueMask from 'v-mask';
import App from './App.vue';
import router from './router';
import store from './store';
import VueViewer from 'v-viewer';
import axios from 'axios';
import { createUnauthorizedHandler, registerAxiosAuthInterceptor } from './services/AxiosAuthInterceptor';

import './scss/global.scss';
import 'viewerjs/dist/viewer.css';

Vue.use(VueMask);
Vue.use(VueViewer);
Vue.component('AppIcon', Icon);

Vue.config.productionTip = false;
const FIRST_LOAD_SESSION_KEY = 'app.session.initialized';
const AUTH_USER_SESSION_KEY = 'vuex.session.authUser';

// Global 401 handler for all axios requests made by services.
registerAxiosAuthInterceptor(axios, createUnauthorizedHandler({ store }));

store.subscribe((mutation, state) => {
  if (['setRegistration', 'setRegistrationField'].includes(mutation.type)) {
    localStorage.setItem('vuex.state.registration', JSON.stringify(state.registration));
  } else if (mutation.type === 'auth/setAuthUser') {
    const authUser = mutation.payload || {};
    if (authUser?.token) {
      // Keep auth in per-tab session storage only.
      sessionStorage.setItem(AUTH_USER_SESSION_KEY, JSON.stringify(authUser));
    } else {
      sessionStorage.removeItem(AUTH_USER_SESSION_KEY);
    }
  }
});

(async () => {
  // Clear cached auth/registration once per browser tab session.
  if (!sessionStorage.getItem(FIRST_LOAD_SESSION_KEY)) {
    await store.dispatch('clearClientState');
    sessionStorage.setItem(FIRST_LOAD_SESSION_KEY, '1');
  }

  //load cached data from localStorage
  await store.dispatch('initialize');
  await store.dispatch('auth/initialize');
  await store.dispatch('voting/initialize');
  await store.dispatch('changeRequests/initialize');

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
})();
